'use strict';

const React = require('react');
const PropTypes = require('prop-types');


const CarouselItem = React.createClass({
    propTypes: {
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
        className: PropTypes.string.isRequired,
        index: PropTypes.number.isRequired
    },

    render() {
        const { className, src, alt, index, ...props } = this.props;
        return (
            <img
                src={src}
                alt={alt}
                className={className}
                data-index={index}
                {...props}
            />
        );
    }
});

module.exports = CarouselItem;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Carousel/CarouselItem.jsx